import {DefaultSubProjectInfo, defaultSubProjectName, SubProjectInfo, subProjectNameType} from "./interface";
import AppInfoGetter from "../../core/app/AppInfoGetter";
import {getSubProject} from "../../redux/redusers/authSlice";
import {from} from "linq-to-typescript";
import {isBlank} from "../../helpers/stringHelper";


const subProjectTypeList:subProjectNameType[] = ['erp'];
export  const getSubProjectInfo=(subProjectType:string,defaultTitle?:string)=>{

    let subProjectInfo:SubProjectInfo = DefaultSubProjectInfo;
    let useOrganization:boolean = true;
    subProjectInfo = DefaultSubProjectInfo;
    subProjectInfo.title = defaultTitle?? AppInfoGetter.Default.project?.title;

    return {useOrganization:useOrganization,subProjectInfo:subProjectInfo};
}

export const getSubProjectInfoFromStorage=(defaultTitle?:string)=>{
    return getSubProjectInfo(getSubProject(),defaultTitle);
}


export const getSubProjectFromTitle=():subProjectNameType=>{

    const pathname = window.location.pathname;
    if(isBlank(pathname)){
        return  defaultSubProjectName;
    }
    const subProjectType = pathname.split('/')[1];
    if(isSubProjectType(subProjectType)){
        return  subProjectType as subProjectNameType;
    }else
    {
        return defaultSubProjectName;

    }
}
export const isSubProjectType=( subProjectType:any)=>{
    if(isBlank(subProjectType)){
            return  false;
    }
    return from(subProjectTypeList).any(
        x => x === subProjectType
    );

}